import { messages as da } from "../../locales/da.js";
import { messages as en } from "../../locales/en.js";
import { messages as fi } from "../../locales/fi.js";
import { messages as nb } from "../../locales/nb.js";
import { messages as sv } from "../../locales/sv.js";
import { i18n } from "@lingui/core";
import { NMPLocale } from "@borealis/locale-common";

export const loadAndActivateI18n = (locale: NMPLocale = "en") => {
	const localeMessages = {
		da,
		en,
		fi,
		nb,
		sv,
	};

	const messagesToActivate = localeMessages[locale] || localeMessages["en"];

	i18n.load(locale, messagesToActivate);
	i18n.activate(locale);
};
